









import {Component, Prop} from 'vue-property-decorator'
import {EventBus} from '@/main'
import Utils from '@/utils'
import ConfirmDialog from '../ConfirmDialog.vue'

@Component({
  components: {
    CheckBox: Utils.loadComponent('proxy/Inputs/CheckBox'),
    Button: Utils.loadComponent('Button'),
    ConfirmDialog,
  },
})
export default class ForceTerminateDialog extends ConfirmDialog {
  @Prop() public checkBoxLabel!: string
  @Prop() public terminateMessages!: string[]

  protected undesiderableCheck: boolean = false
  protected forbiddenCheck: boolean = false

  protected boxChecked: boolean = false

  protected get cost() {
    return this.$currency(this.terminateMessages?.[1] || 0)
  }

  protected confirm() {
    EventBus.$emit('userForcedTerminate')
    this.$dialog.close()
  }
}
